interface SectionDividerProps {
    readonly className?: string;
}

export const SectionDivider = ({ className = "" }: SectionDividerProps) => {
    return (
        <div className={`flex items-center justify-center gap-6 py-6 sm:py-8 ${className}`} aria-hidden="true">
            <span className="h-px w-24 sm:w-40 bg-[var(--hairline)]" />
            <span className="text-2xl text-[var(--accent)] leading-none select-none">❦</span>
            <span className="h-px w-24 sm:w-40 bg-[var(--hairline)]" />
        </div>
    );
};
